import type { ReactNode } from 'react';
import { ArrowSquareOut, DownloadSimple } from '@phosphor-icons/react';
import { isViewableFile } from '@helpdesk/shared';
import { Modal } from './ui.tsx';

export type ViewerFile = { url: string; filename: string; contentType: string };

/** Adresse derselben Datei, die der Server als Download ausliefert. */
export function downloadUrl(url: string): string {
  return `${url}${url.includes('?') ? '&' : '?'}download=1`;
}

/**
 * Fotos und PDFs im eigenen Fenster ansehen, ohne Download. Das PDF zeigt der
 * Browser selbst an; wo er das im Fenster nicht kann (manche Handys), helfen
 * „In neuem Tab öffnen“ und „Herunterladen“.
 */
export function FileViewer({ file, onClose, actions, error }: { file: ViewerFile | null; onClose: () => void; actions?: ReactNode; error?: unknown }) {
  if (!file) return null;
  const pdf = file.contentType === 'application/pdf';
  return (
    <Modal
      open
      closeOnBackdrop
      wide={pdf}
      title={<span className="break-all">{file.filename}</span>}
      onClose={onClose}
      error={error}
      footer={
        <>
          {actions}
          <a className="ad-button-outline ad-button-sm inline-flex items-center gap-2" href={file.url} target="_blank" rel="noreferrer">
            <ArrowSquareOut size={18} aria-hidden />
            In neuem Tab öffnen
          </a>
          <a className="ad-button-outline ad-button-sm inline-flex items-center gap-2" href={downloadUrl(file.url)}>
            <DownloadSimple size={18} aria-hidden />
            Herunterladen
          </a>
        </>
      }
    >
      {pdf ? (
        <iframe src={file.url} title={file.filename} className="h-[72dvh] w-full border border-[var(--border-default)] bg-white" />
      ) : isViewableFile(file.contentType) ? (
        <img src={file.url} alt={file.filename} className="mx-auto max-h-[72dvh] w-auto max-w-full" />
      ) : (
        <p>Für diese Datei gibt es keine Vorschau. Laden Sie sie herunter.</p>
      )}
    </Modal>
  );
}
